/*sm-pragma-loader:trim-start*/ export default function () { return '<div class="sm-ellipsis"></div>'; } 


// WEBPACK FOOTER //
// ./src/components/sm-ellipsis/sm-ellipsis.template.js